import { SyntheticEvent, useCallback, useState } from "react";

export interface BindString {
  value: string;
  onChange: (event: SyntheticEvent) => void;
}

export interface BindNumber {
  value: number;
  onChange: (event: SyntheticEvent) => void;
}

export const useStringInput = (initialValue: string) => {
  const [value, setValue] = useState(initialValue);

  return {
    value,
    setValue,
    reset: useCallback(() => setValue(initialValue), [initialValue]),
    bind: {
      value,
      onChange: (event: SyntheticEvent) => {
        const target = event.target as HTMLInputElement;
        setValue(target.value);
      },
    } as BindString,
  };
};

export const useNumberInput = (initialValue: number | null) => {
  const [value, setValue] = useState(initialValue);

  return {
    value,
    setValue,
    reset: useCallback(() => setValue(initialValue), [initialValue]),
    bind: {
      value,
      onChange: (event: SyntheticEvent) => {
        const target = event.target as HTMLInputElement;
        setValue(parseFloat(target.value));
      },
    } as BindNumber,
  };
};
